import axios from 'axios'

const baseURL = process.env.REACT_APP_BACKEND_URL

const headers = {}
const defaultOptions = { headers }

export const setAuthToken = token => {
  if (token) {
    headers.Authorization = `Bearer ${token}`
  } else {
    delete headers.Authorization
  }
}

// Actions

export const fetchActions = organizationId => {
  return axios.get(
    `${baseURL}/organizations/${organizationId}/actions`,
    defaultOptions
  )
}

export const fetchAction = id => {
  return axios.get(`${baseURL}/actions/${id}`, defaultOptions)
}

export const createAction = (organizationId, action) => {
  return axios.post(
    `${baseURL}/organizations/${organizationId}/actions`,
    action,
    defaultOptions
  )
}

export const saveAction = (id, action) => {
  return axios.put(`${baseURL}/actions/${id}`, action, defaultOptions)
}

export const runAction = (id, inputValues) => {
  return axios.post(
    `${baseURL}/actions/${id}/run`,
    { inputValues },
    defaultOptions
  )
}

// Subscriptions

export const createCheckoutSession = (organizationId, planName) => {
  return axios.post(
    `${baseURL}/organizations/${organizationId}/checkout-sessions`,
    { planName },
    defaultOptions
  )
}

// Databases

export const fetchDatabases = organizationId => {
  return axios.get(
    `${baseURL}/organizations/${organizationId}/databases`,
    defaultOptions
  )
}

export const createDatabase = (organizationId, data) => {
  return axios.post(
    `${baseURL}/organizations/${organizationId}/databases`,
    data,
    defaultOptions
  )
}

export const searchRecords = (databaseId, tableName, query) => {
  return axios.get(
    `${baseURL}/databases/${databaseId}/tables/${tableName}/search`,
    {
      ...defaultOptions,
      params: { query },
    }
  )
}

export const createTestDatabase = organizationId => {
  return axios.post(
    `${baseURL}/organizations/${organizationId}/databases/test-data`,
    null,
    defaultOptions
  )
}

// Organizations

export const updateOrganization = (organizationId, organization) => {
  return axios.put(
    `${baseURL}/organizations/${organizationId}`,
    organization,
    defaultOptions
  )
}

export const fetchOrganizationUsers = organizationId => {
  return axios.get(
    `${baseURL}/organizations/${organizationId}/users`,
    defaultOptions
  )
}

export const removeUser = (organizationId, userId) => {
  return axios.delete(
    `${baseURL}/organizations/${organizationId}/users/${userId}`,
    defaultOptions
  )
}

export const inviteUser = (organizationId, user) => {
  return axios.post(
    `${baseURL}/organizations/${organizationId}/invitations`,
    user,
    defaultOptions
  )
}

export const cancelInvitation = (organizationId, invitationId) => {
  return axios.delete(
    `${baseURL}/organizations/${organizationId}/invitations/${invitationId}`,
    defaultOptions
  )
}

export const fetchSubscription = organizationId => {
  return axios.get(
    `${baseURL}/organizations/${organizationId}/subscription`,
    defaultOptions
  )
}

export const cancelSubscription = organizationId => {
  return axios.delete(
    `${baseURL}/organizations/${organizationId}/subscription`,
    defaultOptions
  )
}

// Users

export const fetchCurrentUser = () => {
  return axios.get(`${baseURL}/users/me`, defaultOptions)
}

export const saveUser = user => {
  return axios.put(`${baseURL}/users/me`, user, defaultOptions)
}

export const login = data => {
  return axios.post(`${baseURL}/sessions`, data)
}

export const signup = data => {
  return axios.post(`${baseURL}/users`, data)
}

export const acceptInvitation = (invitationId, data) => {
  return axios.post(`${baseURL}/invitations/${invitationId}/accept`, data)
}

export const fetchInvitation = invitationId => {
  return axios.get(`${baseURL}/invitations/${invitationId}`, defaultOptions)
}

export const validateEmail = email => {
  return axios.get(`${baseURL}/users/email-availability`, { params: { email } })
}

// Logs

export const fetchLogs = actionId => {
  return axios.get(`${baseURL}/actions/${actionId}/logs`, defaultOptions)
}

// Views

export const fetchViews = organizationId => {
  return axios.get(
    `${baseURL}/organizations/${organizationId}/views`,
    defaultOptions
  )
}

export const fetchView = viewId => {
  return axios.get(`${baseURL}/views/${viewId}`, defaultOptions)
}

export const createView = (organizationId, view) => {
  return axios.post(
    `${baseURL}/organizations/${organizationId}/views`,
    view,
    defaultOptions
  )
}

export const updateView = (viewId, view) => {
  return axios.put(`${baseURL}/views/${viewId}`, view, defaultOptions)
}

export const deleteView = viewId => {
  return axios.delete(`${baseURL}/views/${viewId}`, defaultOptions)
}

export const fetchViewData = (viewId, params) => {
  return axios.get(`${baseURL}/views/${viewId}/data`, {
    ...defaultOptions,
    params,
  })
}

export const fetchViewDetailsData = (viewId, id) => {
  return axios.get(`${baseURL}/views/${viewId}/data/${id}`, defaultOptions)
}

// Airtable

export const getAirtableBases = apiKey => {
  return axios.get(`${baseURL}/airtable/bases`, {
    ...defaultOptions,
    params: { apiKey },
  })
}
